var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('AllHeader',{attrs:{"title":"法人登记证"}}),_c('div',{staticClass:"wrapper"},[_c('Gywm',{attrs:{"title":"法人登记证"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }